<template>
  <div>
    <button-options
      :access="access"
      :hideAdd="true"
      :hideDelete="false"
      :hideDetail="true"
      :hideEdit="false"
      @onDeleteClicked="onDeleteClicked"
      @onEditClicked="onEditClicked"
      @onViewClicked="onViewClicked"/>
  </div>
</template>

<script>
import ButtonOptions from '@/components/directives/button-options';

export default {
  name: 'PermissionEdit',
  components: { ButtonOptions },
  props: ['access', 'permission'],
  computed: {
    data() {
      return { ...this.permission };
    },
  },
  methods: {
    onDeleteClicked() {
      this.$emit('onDeleteClicked', this.permission);
    },
    onEditClicked() {
      this.$emit('onEditClicked', this.permission);
    },
    onViewClicked() {
      this.$emit('onViewClicked', this.permission);
    },
  },
};
</script>

<style scoped>

</style>
